export type FlowBootErrorReason = 'not-found' | 'network' | 'unknown'

interface FlowBootErrorOptions {
  retryable: boolean
  reason?: FlowBootErrorReason
  cause?: unknown
}

export default class FlowBootError extends Error {
  readonly retryable: boolean
  readonly reason: FlowBootErrorReason

  constructor(message: string, { retryable, reason = 'unknown', cause }: FlowBootErrorOptions) {
    super(message, cause !== undefined ? { cause } : undefined)
    this.name = 'FlowBootError'
    this.retryable = retryable
    this.reason = reason
  }
}

export function normalizeFlowBootError(error: unknown): FlowBootError {
  if (error instanceof FlowBootError) return error

  const message = error instanceof Error ? error.message : String(error)
  return new FlowBootError(message, { retryable: true, cause: error })
}
